export const Bio = {
  name: "Gaizkia Adeline",
  roles: [
    "Data Enthusiast",
    "Front End Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/gaizkiaadeline",
  resume:
    "https://drive.google.com/file/d/1nPJNWtRe26D7bLo72Si5C7IjERcsySHO/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/gaizkia-adeline/",
  twitter: "https://twitter.com/#",
  insta: "https://www.instagram.com/gaizkiaadeline/",
  facebook: "https://www.facebook.com/#",
};

export const skills = [
  {
    title: "Data Science",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "R",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/R_logo.svg/640px-R_logo.svg.png",
      },
      {
        name: "Hugging Face",
        image:
          "https://huggingface.co/datasets/huggingface/brand-assets/resolve/main/hf-logo.png",
      },
      {
        name: "Tensorflow",
        image:
          "https://static-00.iconduck.com/assets.00/tensorflow-icon-1911x2048-1m2s54vn.png",
      },
      {
        name: "Keras",
        image:
          "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
      },
      
      {
        name: "OpenCV",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/OpenCV_Logo_with_text_svg_version.svg/640px-OpenCV_Logo_with_text_svg_version.svg.png",
      },
      {
        name: "Sk Learn Kit",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Google Colab",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/d/d0/Google_Colaboratory_SVG_Logo.svg",
      },
    ],
  },

  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      // {
      //   name: "Redux",
      //   image:
      //     "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      // },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      // {
      //   name: "Angular Js",
      //   image:
      //     "https://camo.githubusercontent.com/8886130b3d8aba95dbdd7c4f9a41029606424cc06d1873c1ced87dd55a222fef/68747470733a2f2f616e67756c61722e696f2f6173736574732f696d616765732f6c6f676f732f616e67756c61722f616e67756c61722e737667",
      // },
      
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://filenp.com/images/extension/256/css.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Tailwind Css",
        image:
          "https://www.svgrepo.com/download/374118/tailwind.svg",
      },
      // {
      //   name: "Flutter",
      //   image:
      //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      // },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Laravel",
        image:
          "https://logospng.org/download/laravel/logo-laravel-icon-1024.png",
      },
      {
        name: "PHP",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/PHP-logo.svg/1280px-PHP-logo.svg.png",
      },
      // {
      //   name: "Graph Ql",
      //   image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      // },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Java",
        image:
          "https://www.svgrepo.com/show/184143/java.svg",
      },
      
      // {
      //   name: "Flask",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flask_logo.svg/1280px-Flask_logo.svg.png",
      // },
      // {
      //   name: "Django",
      //   image:
      //     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlFFyY16N5NRhzoG24RqB7x8Ok2t8Bdgs-tuMsOBXS2Q&s",
      // },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "SSMS",
        image:
          "https://www.edureka.co/blog/wp-content/uploads/2019/10/logo.png",
      },
      // {
      //   name: "Postgresql",
      //   image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      // },
      // {
      //   name: "MongoDB",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      // },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Apache Spark",
        image:
          "https://w7.pngwing.com/pngs/263/900/png-transparent-apache-spark-apache-zeppelin-apache-software-foundation-apache-hadoop-tutorial-spark-miscellaneous-text-orange-thumbnail.png",
      },
      // {
      //   name: "Jenkins",
      //   image:
      //     "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
      // },
      // {
      //   name: "Nginx",
      //   image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
      // },
      // {
      //   name: "Grafana",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/1200px-Grafana_logo.svg.png",
      // },
      // {
      //   name: "Kubernetes",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      // },
      // {
      //   name: "Prometheus",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/1200px-Prometheus_software_logo.svg.png",
      // },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      // {
      //   name: "Netlify",
      //   image:
      //     "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      // },
      {
          name: "Looker",
          image:
            "https://www.pngrepo.com/png/354012/512/looker-icon.png",
        },
      {
            name: "Vercel",
            image:
              "https://creazilla-store.fra1.digitaloceanspaces.com/icons/3205024/logo-vercel-icon-md.png",
          },
      
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      // {
      //   name: "Postman",
      //   image:
      //     "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      // },
      // {
      //   name: "Adobe XD",
      //   image:
      //     "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      // },
      {
        name: "Figma",
        image:
          "https://brandlogos.net/wp-content/uploads/2022/05/figma-logo_brandlogos.net_6n1pb.png",
      },
    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "Jetpack Compose",
  //       image:
  //         "https://3.bp.blogspot.com/-VVp3WvJvl84/X0Vu6EjYqDI/AAAAAAAAPjU/ZOMKiUlgfg8ok8DY8Hc-ocOvGdB0z86AgCLcBGAsYHQ/s1600/jetpack%2Bcompose%2Bicon_RGB.png",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },

];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/D4E0BAQGJ5j3fUqrp5Q/company-logo_200_200/0/1708200043507/theheadstarter_logo?e=2147483647&v=beta&t=jjYFdijuNvVbIpOAMy1N6KH3KjEoEGkqb6VzDOaY9DM",
    role: "Software Engineer Fellow",
    company: "Headstarter AI",
    date: "July 2024 - September 2024",
    desc: "• Built and deployed AI projects using React JS, Next.js, Firebase, Clerk, and Vercel, following agile methodologies with weekly sprints and incorporated CI/CD practices for iterative deployment. • Collaborated with 3 Fellows to build and deploy a SaaS product that generates dynamic flashcards based on any topic using the Llama 3.1 LLM via the Groq API, integrated a paywall and custom pricing plans using the Stripe API. • Scaled each web-app to 200+ users, iterated on user feedback to make continuous optimizations.",

    skills: [
      "ReactJS",
      "NextJs",
      "Vercel",
      "Clerk",
      "OpenAI",
      "Material UI",
      "Firebase",
    ],
    doc: "",
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/C560BAQEzl1-pWfDm2A/company-logo_200_200/0/1610079987920?e=2147483647&v=beta&t=PO-0aRycznBseZJ5-5lb5NCqZva_XG17MxIexY8B9WU",
    role: "Mathematics Teacher",
    company: "Xingyun Bimbel & Languages",
    date: "Aug 2022 - Mar 2024",
    desc: "Taught mathematics and other subjects like physics, biology, social science, Excel, etc., to elementary, middle, and high school students. Assisted students with exam preparation, daily coursework, and homework.",
    // skills: [
    //   "Docker",
    //   "Terraform",
    //   "AWS",
    //   "EC2",
    //   "Portainer",
    //   "Nginx",
    //   "JavaScript",
    //   "TypeScript",
    //   "Node Js",
    //   " Next Js",
    // ],
    doc: "",
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/C510BAQEL844OqubuIA/company-logo_200_200/0/1630630142910?e=2147483647&v=beta&t=LM5hgZDE-1LOmSooCGzVPDxLKrPolnNN9D6Cdlf1_dc",
    role: "Scholarship Mentor",
    company: "Bina Nusantara University",
    date: "Oct 2022 - Feb 2023",
    desc: "Mentor for Computer Science Students: • Responsible for helping students improve their grades through personalized study support. • Assist students in mastering Computer Networks, Computational Physics, Object-Oriented Programming, and Database Technology. • Instruct students in SQL and Java programming. • Guide students in using CISCO Packet Tracer for networking simulations. • Provide hands-on experience in Python Power Electronics (PPE), a toolkit used for simulating and analyzing electrical circuits, power converters, and control systems using Python programming. • Deliver instruction on key concepts and calculations required for each course.",
    skills: [
      "Teaching",
    ],
    doc: "",
  },
  // {
  //   id: 3,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
  //   role: "Fullstack Externship",
  //   company: "Flipr",
  //   date: "June 2023 - July 2023",
  //   desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
  //   skills: [
  //     "ReactJS",
  //     "Redux",
  //     "NodeJs",
  //     "Material UI",
  //     "HTML",
  //     "CSS",
  //     "JavaScript",
  //     "Docker",
  //     "AWS",
  //     "MongoDB",
  //   ],
  //   doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1691181448873.jpeg?alt=media&token=ee85eb8f-7247-43cd-9a1d-ce9f58ea62a6",
  // },
  // {
  //   id: 4,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
  //   role: "Android Developer",
  //   company: "DSC KIIT",
  //   date: "Nov2021 - Present",
  //   desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
  //   skills: [
  //     "Leadership",
  //     "Mobile Application Development",
  //     "Kotlin",
  //     "XML",
  //     "Figma",
  //   ],
  // },
  // {
  //   id: 5,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
  //   role: "Open Source Contributor ",
  //   company: "GirlScript Summer of Code",
  //   date: "May 2023 - Present",
  //   desc: "Contributed to different open-source projects and learn from industry experts",
  // },
];

export const education = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/C510BAQEL844OqubuIA/company-logo_200_200/0/1630630142910?e=2147483647&v=beta&t=LM5hgZDE-1LOmSooCGzVPDxLKrPolnNN9D6Cdlf1_dc",
    school: "Bina Nusantara University",
    date: "2021 - 2026",
    grade: "",
    desc: "Ureeka Software Development Community, Bina Nusantara Computer Club (BNCC), Himpunan Mahasiswa Matematika (HIMMAT)",
    degree: "Computer Science and Mathematics (Double Degree Program)",
  },
  // {
  //   id: 1,
  //   img: "https://th.bing.com/th/id/OIP.wcvSh7d9yq-KhkHWBIHuRwAAAA?rs=1&pid=ImgDetMain",
  //   school: "St Yoseph High School",
  //   date: "2017 - 2020",
  //   // grade: "88.2%",
  //   // desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
  //   degree: "Mathematics and Science",
  // },
  // {
  //   id: 2,
  //   img: "https://th.bing.com/th/id/R.72982c76fc3ed4d89ae63a32818f9a87?rik=FdZJqNnua1%2b2oA&riu=http%3a%2f%2f3.bp.blogspot.com%2f-w0J97Ze6p5E%2fUIsFWi-X5hI%2fAAAAAAAAALw%2fkkP5X04YogU%2fs1600%2fmy.jpeg&ehk=AsCKj0DrqRf2Rfhe0z3LlWvO8SAs9hw8QlDHRQpmbC8%3d&risl=&pid=ImgRaw&r=0",
  //   school: "Mardi Yuana",
  //   date: "2017 - 2014",
  //   // grade: "92.3%",
  //   // desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
  //   // degree: "ICSC(X), Science with Computer",
  // },
];

export const projects = [
  {
    id: 11,
    title: "Multilabel Hate Speech Classification Using LLM",
    // date: "Jan 2024 - Dec 2023",
    description:
      "A project focused on building a multilabel classification model to detect hate speech on social media using BERT and ALBERT pretrained models. It includes data augmentation techniques and hyperparameter tuning for optimal performance in identifying abusive content and hate speech.",
    image:
      "https://i.imgur.com/yX1G6K0.png",
    tags: [
      "BERT",
      "ALBERT",
      "Text Mining",
      "textattack",
      "LLM",
      "Classification",
    ],
    category: "data science",
    github: "https://github.com/gaizkiaadeline/Multilabel-Hate-Speech-Classification-Using-LLM",
    // webapp: "https://decisionhub.netlify.app/",
  },
  {
    id: 22,
    title: "Rock Paper Scissor Image Classification",
    // date: "Jan 2024 - Dec 2023",
    description:
      "This image classification project focuses on classifying images of rock, paper, and scissors gestures using machine learning techniques. The model achieved an impressive validation accuracy of 98.86%, indicating its effectiveness in accurately classifying hand gestures.",
    image:
      "https://i.imgur.com/9vny7iq.png",
    tags: [
      "Image Classifications",
      "Image Augmentation",
      "Callback",
      "Sequential Model",
      "Data Generator",
    ],
    category: "data science",
    github: "https://github.com/gaizkiaadeline/Rock-Paper-Scissor-Image-Classification",
    // webapp: "https://decisionhub.netlify.app/",
  },
  {
    id: 20,
    title: "Text Classification using LSTM, Word2Vec, and Adam Optimizer",
    // date: "Jan 2024 - Dec 2023",
    description:
      "This project presents a text classification model built with Long Short-Term Memory (LSTM) networks and Word2Vec embeddings, optimized using the Adam optimizer. The dataset includes textual data labeled into various categories. By employing pre-trained Word2Vec embeddings, the textual data is converted into vectorized representations. These vectors are passed through an LSTM architecture, known for capturing sequential patterns in text. The Adam optimizer ensures efficient and adaptive training of the model, enabling faster convergence.",
    image:
      "https://i.imgur.com/LZvLzrc.png",
    tags: [
      "LSTM",
      "TensorFlow",
      "Keras",
      "Word2Vec",
      "Adam-optimizer",
    ],
    category: "data science",
    github: "https://github.com/gaizkiaadeline/Text-Classification-Model-using-LSTM-and-word2vec-vectorization",
    // webapp: "https://decisionhub.netlify.app/",
  },
  {
    id: 19,
    title: "Text Classification Using LSTM and Skip-gram Vectorization",
    // date: "Jan 2024 - Dec 2023",
    description:
      "Text classification project using an LSTM (Long Short-Term Memory) model and text vectorization with the Skip-gram technique. The task is to classify text data into 20 labels, and the project allows for hyperparameter tuning and modifications to the LSTM architecture.",
    image:
      "https://i.imgur.com/SU017Z6.png",
    tags: [
      "LSTM",
      "Skipgram",
      "Text Classification",
    ],
    category: "data science",
    github: "https://github.com/gaizkiaadeline/Text-Classification-Using-LSTM-and-Skip-gram-Vectorization",
    // webapp: "https://decisionhub.netlify.app/",
  },
  {
    id: 18,
    title: "Credit Card Approval Prediction",
    // date: "Jan 2024 - Dec 2023",
    description:
      "This project focuses on Credit Card Approval Prediction using a dataset from Kaggle. The goal is to predict whether a credit card application will be approved based on applicant data. The project utilizes data preprocessing techniques like encoding categorical variables, handling imbalanced data using SMOTE (Synthetic Minority Over-sampling Technique), and building classification models to evaluate the prediction performance. Various models like Soft Voting, Hard Voting, AdaBoost, and XGBoost are used, and the final model achieved an F1 score of 82% with XGBoost.",
    image:
      "https://i.imgur.com/7bflk7E.png",
    tags: [
      "Machine Learning",
      "XGBoost",
      "AdaBoost",
      "Boosting",
    ],
    category: "data science",
    github: "https://github.com/gaizkiaadeline/Credit-Card-Approval-Prediction",
    // webapp: "https://decisionhub.netlify.app/",
  },
  // {
  //   id: 9,
  //   title: "Trackify",
  //   date: "Jun 2023 - Jul 2023",
  //   description:
  //     "Trackify is a web application designed to streamline task management and enhance productivity in the workplace. It provides a user-friendly interface for employers to keep track of their employees' daily work activities and empowers employees to log their tasks efficiently. \nAdmin Credentials: # Email: testadmin@gmail.com #Password- 123@testadmin, Employee Credentials:	#Email: testemployee@gmail.com	#Password- 123@Testemployee",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
  //   tags: [
  //     "Docker",
  //     "AWS",
  //     "DuckDNS",
  //     "Eslint",
  //     "Husky",
  //     "CI/CD",
  //     "React Js",
  //     "MongoDb",
  //     "Node Js",
  //     "Express Js",
  //     "Redux",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Trackify",
  //   webapp: "https://trackify-management.netlify.app/",
  // },
  {
    id: 0,
    title: "Wine Variety Classifier using Distilbert",
    // date: "Apr 2023 - May 2023",
    description:
      "This project implements a wine variety classification system based on textual descriptions provided by wine experts. Using DistilBERT, a lighter and faster version of BERT, the model aims to classify wine varieties based on detailed descriptions of their taste, aroma, and other characteristics.",
    image:
      "https://i.imgur.com/JzwJOy8.png",
    tags: ["DistilBERT", "fine-tuned", "Text Classification", "Text Mining"],
    category: "data science",
    github: "https://github.com/gaizkiaadeline/Wine-Variety-Classifier-using-Distilbert",
    // webapp: "https://podstream.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 1,
    title: "Clustering and Topic Extraction of Twitter (X) Responses to BSI's 2023 Ransomware Attack",
    // date: "Oct 2022 - Jan 2023",
    description:
      "A project analyzing user tweets about the 2023 BSI ransomware attack using clustering and topic extraction methods. Persona analysis is performed on both approaches, with a comparison of the results to extract key insights.",
    image:
      "https://i.imgur.com/9rKNBNV.png",
    tags: [
      "LDA",
      "Topic Extraction",
      "Topic Modeling",
      "Cluster Analysis",
      "Text Mining",
      "NLTK",
    ],
    category: "data science",
    github: "https://github.com/gaizkiaadeline/Clustering-and-Topic-Extraction-of-Twitter-X-Responses-to-BSI-s-2023-Ransomware-Attack",
    // webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 4,
    title: "Forest Fire Prediction Using Data Mining Techniques",
    // date: "Apr 2023 - May 2023",
    description:
      "This project focuses on predicting forest fire areas using the Fire Weather Index (FWI) dataset. Key methods include the use of Log Transform to normalize the burned area data, improving the performance of linear regression models. Data analysis and visualizations like histograms and QQ plots are utilized to explore patterns and model accuracy.",
    image:
      "https://i.imgur.com/6xpb54t.png",
    tags: ["Data Mining", "Log Transform", "Prediction Modeling", "Linear Regression"],
    category: "data science",
    github: "https://github.com/gaizkiaadeline/Wine-Variety-Classifier-using-Distilbert",
  },
  {
    id: 2,
    title: "Cookpal",
    // date: "Apr 2023 - May 2023",
    description:
      "This project provides a recipe recommendation system that suggests recipes based on the ingredients you have. By analyzing a dataset of recipes, the program computes the similarity between the ingredients you input and those in the dataset to recommend the most relevant dishes.",
    image:
      "https://i.imgur.com/JGLTnIr.png",
    tags: ["NLP", "TF-IDF", "Recomendation System", "Text Mining"],
    category: "data science",
    github: "https://github.com/gaizkiaadeline/Cookpal-TFIDF",
  },
  {
    id: 9,
    title: "Extractive Summarization of News Articles",
    // date: "Apr 2023 - May 2023",
    description:
      "This project applies extractive summarization techniques to a set of three news articles. The summarization process uses a sentence scoring approach, where the top 3 and top 5 highest-scoring sentences from each article are extracted to form the summary. The summaries are then evaluated using the Rouge Score to measure their quality by comparing them to reference summaries.",
    image:
      "https://i.imgur.com/3OZIBKL.png",
    tags: ["Extractive Summarization", "Text Summarization", "Rouge Score", "Text Mining"],
    category: "data science",
    github: "https://github.com/gaizkiaadeline/Extractive-Summarization-of-News-Articles",
  },
  
  {
    id: 6,
    title: "ILKEA",
    // date: "Apr 2023 - May 2023",
    description:
      "This project is a web-based furniture store simulation built using HTML, CSS, and JavaScript. The ILKEA website offers a clean and responsive design, simulating key features of an e-commerce platform, including product displays, member register, and intuitive navigation. The website is designed to showcase frontend development skills, focusing on user-friendly interface and cross-device compatibility.",
    image:
      "https://i.imgur.com/5Re8WWi.png",
    tags: ["HTML", "CSS", "Java Script", "Web Design", "Figma"],
    category: "web app",
    github: "https://github.com/gaizkiaadeline/ILKEA",
    webapp: "https://htmlpreview.github.io/?https://github.com/gaizkiaadeline/ILKEA/blob/main/ILKEA/html/home.html",

  },
  {
    id: 7,
    title: "XiaoDingDong",
    // date: "Apr 2023 - May 2023",
    description:
      "This project is a web-based ordering system for Food & Beverage establishments, built using the Laravel framework. It enables customers to browse menus, place orders, and manage payments seamlessly. The system also provides admin functionality to manage orders, menu items, and track sales data. Features include: User authentication (login/register), Menu browsing and filtering, Cart and order management, Admin dashboard for managing orders and menus (CRUD).",
    image:
      "https://i.imgur.com/iUkUD6k.png",
    tags: ["Laravel", "PHP", "MySQL", "Web Development"],
    category: "web app",
    github: "https://github.com/gaizkiaadeline/XiaoDingDong",

  },
  {
    id: 30,
    title: "TripTacTix",
    // date: "Apr 2023 - May 2023",
    description:
      "This project features the landing page for TripTactix, a travel planning platform designed to simplify trip planning and booking. The landing page includes several key sections to engage users: Join Waitlist – Users can input their email to join the waitlist and receive updates about upcoming features and platform releases. Discover What We Offer – This section highlights TripTactix's core services, such as flight, hotel, and vacation rental bookings, personalized itineraries, and travel recommendations. AI Chatbot – An interactive AI-powered chatbot is available to provide instant support, answering common questions and guiding users through the platform. FAQ – A comprehensive FAQ section answers common queries, helping users understand how to use the platform and what to expect.",
    image:
      "https://i.imgur.com/1Nv1JA8.png",
    tags: ["React", "Nextjs", "Firebase", "Groq API", "AI Chatbot", "Web Development"],
    category: "web app",
    github: "https://github.com/gaizkiaadeline/TripTactix",
    webapp: "https://triptactix-waitlist.netlify.app/",
    

  },
  {
    id: 22,
    title: "BeeInLove",
    // date: "Apr 2023 - May 2023",
    description:
      "Dating App based on user interest and give the user suggestion by the compability score. Features: Insert, View (All, Filter: by Gender), Delete (by UserName), Match (by the compability score), Connect with Database (MySQL)",
    image:
      "https://user-images.githubusercontent.com/90249058/214089075-dda760a7-b4c9-45e3-9491-07e1899267ee.png",
    tags: ["Java", "OOP", "MySQL"],
    category: "web app",
    github: "https://github.com/gaizkiaadeline/BeeInLove",

  },

  // {
  //   id: 2,
  //   title: "Brain Tumor Detection",
  //   date: "Jan 2023 - Mar 2023",
  //   description:
  //     "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
  //   image:
  //     "https://github.com/gaizkiaadeline/Credit-Card-Approval-Prediction",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "machine learning",
  //   github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
  //   webapp: "https://brain-tumor.netlify.app/",
  //   member: [
  //     {
  //       name: "Rishav Chanda",
  //       img: "https://github.com/gaizkiaadeline/Credit-Card-Approval-Prediction",
  //       linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
  //       github: "https://github.com/rishavchanda/",
  //     },
  //     {
  //       name: "Upasana Chaudhuri",
  //       img: "https://avatars.githubusercontent.com/u/100614635?v=4",
  //       linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
  //       github: "https://github.com/upasana0710",
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   title: "Buckoid",
  //   date: "Dec 2021 - Apr 2022",
  //   description:
  //     "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
  //   image:
  //     "https://camo.githubusercontent.com/3ad28aa710d18525f1fc87de056ed53c706d09979589bfd5a773df36653bad38/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
  //   tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Buckoid-Android-App",
  //   webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  // },
  // {
  //   id: 10,
  //   title: "Job Finding App",
  //   date: "Jun 2023 - Jul 2023",
  //   description:
  //     "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
  //   image:
  //     "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
  //   tags: ["React Native", "JavaScript", "Axios"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Job-finder-App",
  //   webapp: "https://github.com/rishavchanda/Job-finder-App",
  // },
  // {
  //   id: 4,
  //   title: "Whatsapp Clone",
  //   date: "Jul 2021",
  //   description:
  //     "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
  //   image:
  //     "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
  //   tags: ["React Js", "Firebase", "Firestore", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
  //   webapp: "https://whatsapp-clone-rishav.web.app",
  // },
  // {
  //   id: 5,
  //   title: "Todo Web App",
  //   date: "Jun 2021",
  //   description:
  //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
  //   image:
  //     "https://camo.githubusercontent.com/84ac6ab6f378348ef28d8184062b7e9e3511a1252ae3966eaa49e8e998f732a7/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
  //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Todo-Web-App",
  //   webapp: "https://rishav-react-todo.netlify.app/",
  // },
  // {
  //   id: 6,
  //   title: "Breaking Bad",
  //   date: "Jun 2021",
  //   description:
  //     "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
  //   image:
  //     "https://camo.githubusercontent.com/937774368308a82419f53dd6eeb4a8675780e119636488b4e3cfe5d34859a72a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
  //   tags: ["React Js", "API", "Axios", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Breaking-Bad",
  //   webapp: "https://breaking-bad-webapp.netlify.app",
  // },
  // {
  //   id: 7,
  //   title: "Quiz App",
  //   date: "Dec 2020 - Jan 2021",
  //   description:
  //     "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
  //   image:
  //     "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
  //   tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
  //   category: "android app",
  //   github: "https://github.com/rishavchanda/Quiz-Earn",
  //   webapp: "https://github.com/rishavchanda/Quiz-Earn",
  // },
  // {
  //   id: 8,
  //   title: "Face Recognition",
  //   date: "Jan 2021",
  //   description:
  //     "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
  //   image:
  //     "https://dontrepeatyourself.org/media/face-recognition-with-python-dlib-and-deep-learning_cezKZBj.png",
  //   tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
  //   category: "data science",
  //   github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  //   webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  // },
];



